const C = {
  name: "Vietnam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.75 2L19.12 10.29L19.13 10.31L13.42 16.02H9.45C9.79 16.61 10 17.29 10 18.02C10 20.23 8.21 22.02 6 22.02C3.79 22.02 2 20.23 2 18.02C2 17.29 2.21 16.61 2.55 16.02H1V15.02C1 13.1 1.48 11.59 2.26 10.42C2.63 9.86 3.06 9.41 3.51 9.02H1V7.02H11.4L14.4 10.02L12.99 11.43L10.58 9.02H8.77C8.6 9.03 8.36 9.05 8.07 9.1C7.48 9.19 6.71 9.39 5.95 9.77C5.2 10.15 4.47 10.7 3.93 11.51C3.51 12.13 3.19 12.94 3.06 14H12.59L16.88 9.71L15.25 4H11V2H16.75ZM6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20Z" fill="currentColor"/>
<path d="M15 18C15 15.79 16.79 14 19 14C21.21 14 23 15.79 23 18C23 20.21 21.21 22 19 22C16.79 22 15 20.21 15 18ZM17 18C17 19.1 17.9 20 19 20C20.1 20 21 19.1 21 18C21 16.9 20.1 16 19 16C17.9 16 17 16.9 17 18Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Vietnam
};
